var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "leftCardContainer" },
    [
      _c("div", { staticClass: "rightSideTitleActions" }, [
        _c("span", { staticClass: "leftTitle" }, [
          _vm._v(_vm._s(_vm.$t("NetworkRules")))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "actionsContainer" },
          [
            _c(
              "div",
              { staticClass: "searchContainer" },
              [
                _c("v-icon", [_vm._v(" search ")]),
                _vm._v(" "),
                _c("InputField", {
                  attrs: {
                    inputType: "text",
                    value: _vm.search,
                    placeholder: _vm.$t("Search"),
                    inputStyle: {
                      borderRadius: "0px",
                      width: "130px",
                      borderTop: "none",
                      borderRight: "none",
                      borderLeft: "none",
                      borderBottom: "1px solid rgba(118, 118, 118, 0.50)"
                    }
                  },
                  on: {
                    input: function($event) {
                      return _vm.handleSearch($event)
                    }
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("CustomButton", {
              attrs: {
                icon: "delete",
                width: "20px",
                height: "20px",
                iconSize: 12,
                disabled:
                  !_vm.selectedObjectID ||
                  !_vm.userHasPermission("network_rule_destroy"),
                buttonStyling: {
                  padding: "8px",
                  marginRight: "5px",
                  borderRadius: "4px"
                }
              },
              on: { buttonClick: _vm.openDeleteDialog }
            }),
            _vm._v(" "),
            _c("CustomButton", {
              attrs: {
                icon: "add",
                width: "20px",
                height: "20px",
                iconSize: 12,
                buttonStyling: {
                  padding: "8px",
                  marginRight: "5px",
                  borderRadius: "4px"
                },
                disabled:
                  _vm.userIsCreatingOrEditingData ||
                  !_vm.userHasPermission("network_rule_store")
              },
              on: { buttonClick: _vm.handleAdd }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tableDivContainer" },
        [
          _c("Table", {
            attrs: {
              checkbox: false,
              loading: _vm.loading,
              headers: _vm.headers,
              items: _vm.networkRules,
              sortable: true,
              emitRowClickBusEvent: true
            },
            on: {
              onScrollBottom: _vm.onScrollBottom,
              onScrollTop: _vm.onScrollTop,
              sortClick: _vm.onSortClick
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("dialog-choice", {
        attrs: {
          isOpen: _vm.deleteDialogIsOpen,
          title: _vm.$t("DeleteNetworkRule"),
          content: _vm.$t("DeleteNetworkRuleConfirmation"),
          mainActionLabel: _vm.$t("Confirm"),
          secondaryActionLabel: _vm.$t("Cancel"),
          icon: "mdi-delete",
          iconColor: "var(--app-primary-base)"
        },
        on: {
          mainAction: _vm.handleDelete,
          secondaryAction: function($event) {
            _vm.deleteDialogIsOpen = false
          }
        }
      }),
      _vm._v(" "),
      _c("loading-spinner", {
        staticStyle: { position: "absolute" },
        attrs: {
          active: _vm.loading,
          "is-full-page": false,
          color: "var(--app-primary-base)"
        },
        on: {
          "update:active": function($event) {
            _vm.loading = $event
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-60c57b05", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60c57b05","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/newComponents/SystemSettingsManagement/NetworkRules/TableView.vue
// module id = null
// module chunks = 